<script lang="ts" setup>
import type { Product } from '~~/server/api/menu/main'

export interface SubmenuCategoryProductsProps {
    products: Product[]
    categorySlug: string
}

const props = defineProps<SubmenuCategoryProductsProps>()

const getLink = (product: Product): VNuxtLinkTo => {
    if (product.meta_product)
        return {
            name: `${product.slug}`,
        }

    return {
        name: 'insurance-detail',
        params: {
            id: product.slug,
            category: props.categorySlug,
        },
    }
}
</script>

<template>
  <ul class="row">
    <li
      v-for="(product, index) in props.products"
      :key="`smscp-${index}`"
      class="col-12 col-md-6"
      :class="{
        'mb-md-2': index < props.products.length - 2,
        'mb-md-0': index >= props.products.length - 2,
        'mb-4': product.subtitle,
        'mb-2': !product.subtitle,
      }"
    >
      <VNuxtLink
        :to="getLink(product)"
        class="submenu-category-sublink fs-xsmall text-decoration-none d-flex flex-column text-black"
      >
        <span
          class="fs-smaller fw-bold"
          :class="{ 'mb-md-1': product.subtitle }"
        >
          {{ product.title }}
        </span>
        {{ product.subtitle }}
      </VNuxtLink>
    </li>
  </ul>
</template>
